// extracted by mini-css-extract-plugin
export var view = "view-module--view--8zXBK";